import axios from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { fingerprint, sessionId } from '@/main';
import i18n from '@/i18n';
import config from './config';

const API_VERSION = 5;

const instance = axios.create({
  baseURL: config.apiURL
});


const getAppVersion = () => {
  const version = config.appVersion;
  const release = config.release;
  if (version && release) return `${version}-${release[0]}`;
  return version || release || undefined;
};

export const getRequestHeaderParams = () => {
  const appVersion = getAppVersion();
  return {
    'Accept-language': i18n.language,
    'X-Request-ID': uuidv4(),
    'X-Fingerprint': fingerprint,
    'X-Session-ID': sessionId,
    'X-Api-Version': API_VERSION,
    ...(appVersion && { 'X-App-Version': appVersion }),
  };
};

export default instance;
